// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminModeController from "./admin_mode_controller"
application.register("admin-mode", AdminModeController)

import AutoRefreshController from "./auto_refresh_controller"
application.register("auto-refresh", AutoRefreshController)

import CalculatorController from "./calculator_controller"
application.register("calculator", CalculatorController)

import CanonicalizationSelectAllController from "./canonicalization_select_all_controller"
application.register("canonicalization-select-all", CanonicalizationSelectAllController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CostAlertSettingsController from "./cost_alert_settings_controller"
application.register("cost-alert-settings", CostAlertSettingsController)

import CostAlertTrendController from "./cost_alert_trend_controller"
application.register("cost-alert-trend", CostAlertTrendController)

import CostCalculatorController from "./cost_calculator_controller"
application.register("cost-calculator", CostCalculatorController)

import DecimalInputController from "./decimal_input_controller"
application.register("decimal-input", DecimalInputController)

import DevLintController from "./dev_lint_controller"
application.register("dev-lint", DevLintController)

import DocumentBulkActionsController from "./document_bulk_actions_controller"
application.register("document-bulk-actions", DocumentBulkActionsController)

import DocumentUploadSessionController from "./document_upload_session_controller"
application.register("document-upload-session", DocumentUploadSessionController)

import DocumentUploadZoneController from "./document_upload_zone_controller"
application.register("document-upload-zone", DocumentUploadZoneController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FileSizeValidatorController from "./file_size_validator_controller"
application.register("file-size-validator", FileSizeValidatorController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import IframeLoaderController from "./iframe_loader_controller"
application.register("iframe-loader", IframeLoaderController)

import ImageViewerController from "./image_viewer_controller"
application.register("image-viewer", ImageViewerController)

import ImpersonationBannerController from "./impersonation_banner_controller"
application.register("impersonation-banner", ImpersonationBannerController)

import IngredientBulkSubmitController from "./ingredient_bulk_submit_controller"
application.register("ingredient-bulk-submit", IngredientBulkSubmitController)

import IngredientCsvImportModalController from "./ingredient_csv_import_modal_controller"
application.register("ingredient-csv-import-modal", IngredientCsvImportModalController)

import IngredientImportListController from "./ingredient_import_list_controller"
application.register("ingredient-import-list", IngredientImportListController)

import IngredientPriceModalController from "./ingredient_price_modal_controller"
application.register("ingredient-price-modal", IngredientPriceModalController)

import IngredientSuggestionsController from "./ingredient_suggestions_controller"
application.register("ingredient-suggestions", IngredientSuggestionsController)

import IngredientUnitController from "./ingredient_unit_controller"
application.register("ingredient-unit", IngredientUnitController)

import IngredientsTableController from "./ingredients_table_controller"
application.register("ingredients-table", IngredientsTableController)

import IngredientsTableSpreadsheetController from "./ingredients_table_spreadsheet_controller"
application.register("ingredients-table-spreadsheet", IngredientsTableSpreadsheetController)

import InlineResourceCreatorController from "./inline_resource_creator_controller"
application.register("inline-resource-creator", InlineResourceCreatorController)

import IngredientTagPickerController from "./ingredient_tag_picker_controller"
application.register("ingredient-tag-picker", IngredientTagPickerController)

import MatchChoiceController from "./match_choice_controller"
application.register("match-choice", MatchChoiceController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import OcrEvidenceViewerController from "./ocr_evidence_viewer_controller"
application.register("ocr-evidence-viewer", OcrEvidenceViewerController)

import OcrSourceRowController from "./ocr_source_row_controller"
application.register("ocr-source-row", OcrSourceRowController)

import PdfViewerController from "./pdf_viewer_controller"
application.register("pdf-viewer", PdfViewerController)

import PortionSummaryController from "./portion_summary_controller"
application.register("portion-summary", PortionSummaryController)

import PriceChartController from "./price_chart_controller"
application.register("price-chart", PriceChartController)

import SelectionController from "./selection_controller"
application.register("selection", SelectionController)

import IngredientBulkActionsController from "./ingredient_bulk_actions_controller"
application.register("ingredient-bulk-actions", IngredientBulkActionsController)

import SafariImageViewerController from "./safari_image_viewer_controller"
application.register("safari-image-viewer", SafariImageViewerController)

import SimulationController from "./simulation_controller"
application.register("simulation", SimulationController)

import SlugPreviewController from "./slug_preview_controller"
application.register("slug-preview", SlugPreviewController)

import StaffRoleHelpController from "./staff_role_help_controller"
application.register("staff-role-help", StaffRoleHelpController)

import SupplierConfirmationController from "./supplier_confirmation_controller"
application.register("supplier-confirmation", SupplierConfirmationController)

import SupplierEditorController from "./supplier_editor_controller"
application.register("supplier-editor", SupplierEditorController)

import SupplierMergeController from "./supplier_merge_controller"
application.register("supplier-merge", SupplierMergeController)

import SupplierNameEditorController from "./supplier_name_editor_controller"
application.register("supplier-name-editor", SupplierNameEditorController)

import TurboFrameLoadingController from "./turbo_frame_loading_controller"
application.register("turbo-frame-loading", TurboFrameLoadingController)
